import { render, staticRenderFns } from "./InitPassword.vue?vue&type=template&id=2bdcb250&scoped=true&"
import script from "./InitPassword.vue?vue&type=script&lang=js&"
export * from "./InitPassword.vue?vue&type=script&lang=js&"
import style0 from "./InitPassword.vue?vue&type=style&index=0&id=2bdcb250&lang=less&scoped=true&"
import style1 from "./InitPassword.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdcb250",
  null
  
)

export default component.exports